const API_VERSION = '1.2';

// Backend API endpoints
export const API_GET_CONTRACT = `/api/${API_VERSION}/contracts/user/`;
export const API_GET_CONTRACT_BY_USER = `/api/${API_VERSION}/contracts/user`;
export const API_GET_CONTRACT_INFO = `/api/${API_VERSION}/contracts/info`;
export const API_GET_DOMAINS = `/api/${API_VERSION}/forecast/domains?take=1000&skip=0`;

export const API_GET_PARAMETERS = (domain) => `/api/${API_VERSION}/forecast/parameters/${domain}?take=1000&skip=0`;
export const API_GET_PARAMETERLAYERS = `/api/${API_VERSION}/parameterlayers?take=1000&skip=0`;
export const API_GET_USERS = `/api/${API_VERSION}/auth/users/role/authUser?take=1000&skip=0`;
export const API_GET_ALL_USERS = `/api/${API_VERSION}/auth/users/all`;
export const API_EDIT_CONTRACT = `/api/${API_VERSION}/contracts`;
export const API_CREATE_CONTRACT = `/api/${API_VERSION}/contracts`;
export const API_GET_CONTRACTS = `/api/${API_VERSION}/contracts/user`;
export const API_GET_PREDICT_RANGES = `/api/cabinet/predictranges`;
export const API_GET_PRESETS = (userId, take, skip) => `/api/${API_VERSION}/presets/user/${userId}?take=${take}&skip=${skip}`;
export const API_GET_PRESETS_COUNT = () => `/api/${API_VERSION}/presets/count`;
export const API_GET_PRESETS_COUNT_USER = (userId) => `/api/${API_VERSION}/presets/count/user/${userId}`;
export const API_GET_ORDER_PRESETS = `/api/${API_VERSION}/orderpresets/user`;
export const API_GET_USER_PRESETS = (take, skip) => `/api/${API_VERSION}/presets?take=${take}&skip=${skip}`;
export const API_GET_USER_ORDER_PRESETS = `/api/${API_VERSION}/orderpresets`;
export const API_GET_PRESET = `/api/${API_VERSION}/presets/user`;
export const API_GET_PRESET_NAMES = (userId, take, skip) => `/api/${API_VERSION}/presets/user/${userId}/names?take=${take}&skip=${skip}`;
export const API_CREATE_PRESET = `/api/${API_VERSION}/presets/create`;
export const API_DELETE_PRESET = `/api/${API_VERSION}/presets/user`;
export const API_UPDATE_PRESET = `/api/${API_VERSION}/presets`;
export const API_DELETE_ORDER_PRESET = `/api/${API_VERSION}/orderpresets/user`;
export const API_GET_REANALYS = `/api/${API_VERSION}/reanalysis/user`;
export const API_REANALYS = `/api/${API_VERSION}/reanalysis`;

export const API_GET_REANALYS_REPORT = (userId, dateStart, dateEnd, lon, lat) => `/api/reports/reanalysis/report?userId=${userId}&dateStart=${dateStart}&dateEnd=${dateEnd}&lon=${lon}&lat=${lat}`;
export const API_GET_REANALYS_REPORT_POINT = (userId, from, to, presetId) => `/api/reports/reanalysis/points?userId=${userId}&dateStart=${from}&dateEnd=${to}&presetId=${presetId}`;


//forecast
export const API_FORECAST_LAST_BY_POINT_USER = (userId, latitude, longitude) => `/api/${API_VERSION}/forecast/user/${userId}/point?latitude=${latitude}&longitude=${longitude}`;
export const API_GET_LAST_FORECAST_PRESET_BY_PARAMS = `/api/${API_VERSION}/forecast`;
export const API_GET_LAST_FORECAST_PRESET = `/api/${API_VERSION}/forecast/user`;
export const API_GET_FORECAST = `/api/${API_VERSION}/forecast`;
export const API_GET_LAST_FORECAST_PRESET_REPORT = `/api/${API_VERSION}/forecast/report`;
export const URL_FORECAST_RESULT = `/forecasts/result`;
export const API_FORECAST_LAST_TIME = `/api/${API_VERSION}/forecast/time`;
export const API_FORECAST_LAST_TIME_USER = (userId) => `/api/${API_VERSION}/forecast/user/${userId}/time`;
export const API_FORECAST_DOMAIN_PREDICTS = (domainName) => `/api/${API_VERSION}/forecast/domains/${domainName}/predicts`;
export const API_FORECAST_DOMAINS_PREDICTS = (take, skip) => `/api/${API_VERSION}/forecast/domains/predicts?take=${take}&skip=${skip}`;

export const URL_EDIT_CONTRACT = `/contract`;
export const URL_PRESETS = `/presets/list`;

export const API_BILLING_AREA = `/api/${API_VERSION}/billing/area/user`;
export const API_USER_BILLING_AREA = `/api/${API_VERSION}/billing/area`;
export const API_BILLING_REQUESTS = `/api/${API_VERSION}/billing/requests/user`;
export const API_USER_BILLING_REQUESTS = `/api/${API_VERSION}/billing/requests`;
export const API_BILLING_DETAIL = `/api/${API_VERSION}/billing/today`;
export const API_GET_BILLING = `/api/${API_VERSION}/billing`;
export const API_GET_BILLING_COUNT = (userId, from, to, dataType) => `/api/${API_VERSION}/billing/count/${userId}?from=${from}&to=${to}&dataType=${dataType}`;
export const API_BILLING_RADAR_INFO = `/api/${API_VERSION}/billing/radar/info`;
export const API_BILLING_USER_RADAR_INFO = (userId) => `/api/${API_VERSION}/billing/radar/${userId}`;
export const API_BILLING_USER_REQUESTS_REPORT = (userId, territory, from, to, timezoneOffset) => `/api/reports/radar/billing/${userId}/${territory}?from=${from}&to=${to}&timezoneOffset=${timezoneOffset}`;
export const API_BILLING_ALL_USERS_REPORT = (from, to, timezoneOffset) => `/api/reports/billing/all?from=${from}&to=${to}&timezoneOffset=${timezoneOffset}`;

export const API_FORECAST_POINTS_REPORT = () => `/api/reports/forecast/points`;
export const API_FORECAST_POINT_REPORT = (userId, latitude, longitude) => `/api/reports/forecast/point/${userId}?longitude=${longitude}&latitude=${latitude}`;

export const API_BILLING_STATISTICS = (from, to) => `/api/${API_VERSION}/billing/radar/statistics?from=${from}&to=${to}`;
export const API_BILLING_STATISTICS_USER = (userId, from, to) => `/api/${API_VERSION}/billing/radar/statistics/${userId}?from=${from}&to=${to}`;

export const API_CREATE_USER = `/api/${API_VERSION}/auth/users/`;
export const API_GET_USER = `/api/${API_VERSION}/auth/user`;
export const API_EDIT_USER = `/api/${API_VERSION}/auth/users`;

//billing geomap
export const API_BILLING_GEOMAP_REQUEST_INFO = () => `/api/${API_VERSION}/billing/geomap/info`;
export const API_BILLING_GEOMAP_REQUEST_INFO_USER = (userId) => `/api/${API_VERSION}/billing/geomap/${userId}`;
export const API_BILLING_GEOMAP_STATISTICS = (userId, from, to) => `/api/${API_VERSION}/billing/geomap/statistics?from=${from}&to=${to}`;
export const API_BILLING_GEOMAP_STATISTICS_USER = (userId, from, to) => `/api/${API_VERSION}/billing/geomap/statistics/${userId}?from=${from}&to=${to}`;

// radars
export const API_RADAR_TERRITORIES = `/api/${API_VERSION}/radar/territories`;
export const API_RADAR_LAST_BASETIME = (territory, parameter) => `/api/${API_VERSION}/radar/basetime/${territory}/${parameter}/last`;
export const API_RADAR_VALIDTIMES = (territory, parameter, basetime) => `/api/${API_VERSION}/radar/validtime/${territory}/${parameter}/${basetime}`;
export const API_RADAR_GEOJSON = (territory, parameter, validtimes) => `/api/${API_VERSION}/radar/${territory}/${parameter}/${validtimes}`;
export const API_CREATE_RADAR_CONTRACT = `/api/${API_VERSION}/radarcontracts`;
export const API_EDIT_RADAR_CONTRACT = `/api/${API_VERSION}/radarcontracts`;
export const API_DELETE_RADAR_CONTRACT = (userId, contractId) => `/api/${API_VERSION}/radarcontracts/user/${userId}/${contractId}`;
export const API_RADAR_CONTRACTS = (userId, take, skip) => `/api/${API_VERSION}/radarcontracts/user/${userId}?take=${take}&skip=${skip}`;
export const API_RADAR_CONTRACT = (userId, contractId) => `/api/${API_VERSION}/radarcontracts/user/${userId}/${contractId}`;

// forecastlong
export const API_FORECAST_LONG_LAST_BY_POINT_USER = (userId, latitude, longitude) => `/api/${API_VERSION}/forecast/long/point/user/${userId}?latitude=${latitude}&longitude=${longitude}`;
export const API_FORECAST_LONG_LAST_BY_PRESET_USER = (userId, presetId) => `/api/${API_VERSION}/forecast/long/user/${userId}/preset/${presetId}`;
export const API_FORECAST_LONG_LAST_BY_POINT = (latitude, longitude) => `/api/${API_VERSION}/forecast/long/point?latitude=${latitude}&longitude=${longitude}`;
export const API_FORECAST_LONG_LAST_TIME = `/api/${API_VERSION}/forecast/long/time`;
export const API_FORECAST_LONG_LAST_TIME_USER = (userId) => `/api/${API_VERSION}/forecast/long/time/${userId}`;
export const API_FORECASTLONG_DOMAIN_PREDICTS = (domainName) => `/api/${API_VERSION}/forecast/domains/${domainName}/predicts`;
export const API_FORECASTLONG_DOMAINS_PREDICTS = (take, skip) => `/api/${API_VERSION}/forecast/domains/predicts?take=${take}&skip=${skip}`;


//geomap
export const API_GEOMAP_LAST_ISOLINE = (territory, parameter) => `/api/${API_VERSION}/geomap/${territory}/${parameter}/isoline/last`;
export const API_GEOMAP_LAST_POLYGON = (territory, parameter) => `/api/${API_VERSION}/geomap/${territory}/${parameter}/polygon/last`;
export const API_GEOMAP_ISOLINE = (territory, parameter, basetime) => `/api/${API_VERSION}/geomap/basetime/${territory}/${parameter}/${basetime}/isoline`;
export const API_GEOMAP_POLYGON = (territory, parameter, basetime) => `/api/${API_VERSION}/geomap/basetime/${territory}/${parameter}/${basetime}/polygon`;
export const API_GEOMAP_VALID_ISOLINE = (territory, parameter, validtimes) => `/api/${API_VERSION}/geomap/${territory}/${parameter}/${validtimes}/isoline`;
export const API_GEOMAP_VALID_POLYGON = (territory, parameter, validtimes) => `/api/${API_VERSION}/geomap/${territory}/${parameter}/${validtimes}/polygon`;
export const API_GEOMAP_LAST_BASETIME = (territory, parameter) => `/api/${API_VERSION}/geomap/basetime/${territory}/${parameter}/last`;
export const API_GEOMAP_LAST_VALIDTIME = (territory, parameter) => `/api/${API_VERSION}/geomap/validtime/${territory}/${parameter}/last`;
export const API_GEOMAP_BASETIMES = (territory) => `/api/${API_VERSION}/geomap/basetime/${territory}`;
export const API_GEOMAP_VALIDTIMES = (territory, parameter) => `/api/${API_VERSION}/geomap/validtime/${territory}/${parameter}`;
export const API_GEOMAP_VALIDTIMES_BASETIME = (territory, parameter, basetime) => `/api/${API_VERSION}/geomap/validtime/${territory}/${parameter}/${basetime}`;
export const API_GEOMAP_TERRITORIES = () => `/api/${API_VERSION}/geomap/territories`;

//geomapcontracts
export const API_GEOMAP_CONTRACTS_CREATE = () => `/api/${API_VERSION}/geomapcontracts`;
export const API_GEOMAP_CONTRACTS_GET_USER = (userId, take, skip) => `/api/${API_VERSION}/geomapcontracts/user/${userId}?take=${take}&skip=${skip}`;
export const API_GEOMAP_CONTRACTS_GET_CONTRACT = (userId, contractId) => `/api/${API_VERSION}/geomapcontracts/user/${userId}/${contractId}`;
export const API_GEOMAP_CONTRACTS_UPDATE = () => `/api/${API_VERSION}/geomapcontracts`;
export const API_GEOMAP_CONTRACTS_DELETE_CONTRACT = (userId, contractId) => `/api/${API_VERSION}/geomapcontracts/user/${userId}/${contractId}`;


//synopcontracts
export const API_SYNOP_CONTRACTS_CREATE = () => `/api/${API_VERSION}/synopcontracts`;
export const API_SYNOP_CONTRACTS_GET_USER = (userId, take, skip) => `/api/${API_VERSION}/synopcontracts/user/${userId}?take=${take}&skip=${skip}`;
export const API_SYNOP_CONTRACTS_GET_CONTRACT = (userId, contractId) => `/api/${API_VERSION}/synopcontracts/user/${userId}/${contractId}`;
export const API_SYNOP_CONTRACTS_UPDATE = () => `/api/${API_VERSION}/synopcontracts`;
export const API_SYNOP_CONTRACTS_DELETE_CONTRACT = (userId, contractId) => `/api/${API_VERSION}/synopcontracts/user/${userId}/${contractId}`;

//synop
export const API_SYNOP_STATIONS = (take, skip) => `/api/${API_VERSION}/synop/stations/all?take=${take}&skip=${skip}`;
export const API_SYNOP_STATIONS_BY_INDEXES = (indexes) => `/api/${API_VERSION}/synop/stations?indexes=${indexes}`;
export const API_SYNOP_MEASUREMENTS = (indexes, from, to) => `/api/${API_VERSION}/synop/measurements/?indexes=${indexes}&from=${from}&to=${to}`;
export const API_SYNOP_MEASUREMENTS_LAST = (indexes) => `/api/${API_VERSION}/synop/measurements/last?indexes=${indexes}`;
export const API_SYNOP_MEASUREMENTS_LOCATION = (lat, lon, from, to) => `/api/${API_VERSION}/synop/measurements/location?lat=${lat}&lon=${lon}&from=${from}&to=${to}`;

export const NOWCASTING_INTERVALS = [
  {
    from: 0,
    to: 1,
    img: require("@/assets/weather/Clear.svg"),
    opacity: 0.1,
    color: '#3388ff'
  },
  {
    from: 2,
    to: 3,
    img: require("@/assets/weather/Clouds.svg"),
    opacity: 0.2,
    color: '#3388ff'
  },
  {
    from: 4,
    to: 10,
    img: require("@/assets/weather/Clouds.svg"),
    opacity: 0.3,
    color: '#3388ff'
  },
  {
    from: 11,
    to: 20,
    img: require("@/assets/weather/Clouds.svg"),
    opacity: 0.4,
    color: '#3388ff'
  },
  {
    from: 21,
    to: 30,
    img: require("@/assets/weather/Rain.svg"),
    opacity: 0.5,
    color: '#3388ff'
  },
  {
    from: 31,
    to: 1000,
    img: require("@/assets/weather/Thunderstorm.svg"),
    opacity: 0.6,
    color: '#3388ff'
  },
]

export const WapiDataType = Object.freeze({ "Forecast": 0, "Reanalys": 1, "Radar": 2 });
export const WapiRequestType = Object.freeze({ "Point": 0, "Preset": 1, "ValidTimes": 2 });
export const WapiRoles = Object.freeze({ "Admin": "admin" });
export const WapiCoordinateOrder = Object.freeze({ 'LatLon': [1, 0], 'LonLat': [0, 1], });

export const LAT_LON = "LAT_LON";
export const LON_LAT = "LON_LAT";


export const GetWapiCoordinateOrder = (arr) => {
  if ((arr[0] === 0) && (arr[1] === 1)) return WapiCoordinateOrder.LonLat;

  return WapiCoordinateOrder.LatLon;
}

export const GetWapiCoordinateOrderType = (arr) => {
  if ((arr[0] === 0) && (arr[1] === 1)) return LON_LAT;

  return LAT_LON;
}
